<!-- 车辆选择列表-->
<template>
    <div>
        <el-form ref="elForm" size="medium" label-width="120px">
            <el-form-item label="车牌号" prop="dd">
                <el-input v-model="listQuery.devNo" placeholder="车牌号搜索" clearable
                    :style="{ width: '763px' }"></el-input>
            </el-form-item>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search" @click="getList">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" @selection-change="handleSelectionChange" v-loading="listLoading" size="small" stripe
            highlight-current-row ref="multipleTable">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column property="devNo" label="车牌号"></el-table-column>
            <el-table-column property="devType" label="车型"></el-table-column>
            <el-table-column property="" label="监管状态">
                <template slot-scope="scope">{{ scope.row.useType == 1 ? '租用' : '自有' }}</template>
            </el-table-column>
        </el-table>
        <div v-show="!listLoading" class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
        </div>

    </div>
</template>

<script>
import {
    page,
    getObj
} from '@/api/admin/sysCarMeta'
import {
    mapGetters
} from 'vuex';
import templet from '../templet.vue';
export default {
    components: {
        templet
    },
    name: 'truckInComponents',
    props: {
        selectedIds: {
            type: Array,
            required: false,
            default: []
        }
    },
    data() {
        return {
            listQuery: {
                page: 1,
                limit: 10
            },
            listLoading: false,
            list: [],
            total: 0,
            values: [],
        }
    },
    watch: {
        selectedIds(n) {
            this.values = n;
            this.defaultCheckedRows();
        }
    },
    computed: {
    },
    created() {
        this.values = this.selectedIds;
        this.defaultCheckedRows();
        this.getList()
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        defaultCheckedRows() {
            let selectIds = this.values || [];
            this.list.forEach(row => {
                if (selectIds.includes(row.devNo)) {
                    this.$nextTick(() => {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    });
                }
            });
        },
        getList() {
            let self = this;
            this.listLoading = true;
            let query = {
                ...this.listQuery
            };
            page(query).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
                this.defaultCheckedRows();
            })
        },
        handleSelectionChange(val) {
            this.$emit("input", val)

        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 10
            }
        }
    }
}
</script>

<style scoped></style>
